import {
  setLocaleData, setMetaData, setProducts,
} from '../actions/load';
import makeApiRequest from '../utils/makeApiRequest';
import makeOrCacheApiReq from '../utils/apiCache';
import { readCookie } from '../utils/cookies-browser';
import { checkMobile } from '../utils/redirectToMobileSite.mjs';
import { getHostName } from '../utils/urlUtils';
import metaInfo from '../config/metaInfo';

import { getProducts } from '../actions/actionsSet/assetService';

import { setPublicAssetsStatus, hideHeaderLangSelect } from '../actions/actionsSet/userConfig';
import {
  wssUri,
} from './handleInitTask';

const {
  brands, metaTitles, metaKeywords, metaDescriptions,
} = metaInfo;

// node apis served in server.js
const I18N_API_PATH = (isServer, locale) => isServer ?
  `http://localhost:${process.env.PORT || 3000}/en/i18n/${locale}.json` : `/en/i18n/${locale}.json`;

export type Context = {
  isServer: boolean,
  req: any,
  query: any,
  store: Object,
  res: any,
  pathname: String
};

// !!! only ONE `await` allowed in this code !!!
export default async (
  {
    isServer, req, query, store, pathname
  }: Context,
  {
    withProductsData,
  } = {
    withProductsData: false,
    realRedirect: true,
  }
) => {
  // client side only mobile redirect
  const shouldPublicAssets = isServer ? req.cookies.shouldPublicAssets : readCookie('shouldPublicAssets');
  store.dispatch(setPublicAssetsStatus(shouldPublicAssets === 'true'));

  const isHideHeadLangSeclet = isServer ? req.cookies.isHideHeadLangSeclet : readCookie('isHideHeadLangSeclet');
  store.dispatch(hideHeaderLangSelect(isHideHeadLangSeclet === 'true'));

  // only ONE `await` allowed in this code
  const promises = []; // do requests ASYNC
  const locale = (query || {}).locale || 'en';

  if (withProductsData) {
    // 1
    promises.push(getProducts(req));
  }

  let localeData = store.getState().localeData[locale];

  if (!localeData) {
    // 3
    promises.push(
      makeOrCacheApiReq(
        `beta-i18n-${locale}`,
        () => makeApiRequest(I18N_API_PATH(isServer, locale), req, null, null, true)
      )
    );
  }

  // FETCH in parallel
  const [...responses] = await Promise.all(promises);

  if (withProductsData) {
    // 1
    const products = responses.shift();
    store.dispatch(setProducts(products));
  }

  // 3
  if (!localeData) localeData = responses.shift();
  store.dispatch(setLocaleData(locale, localeData));

  const metaData = {
    title: (metaTitles[locale] || metaTitles.en) || `${localeData.Binance || brands[locale] || 'Binance'}`,
    keywords: (metaKeywords[locale] || metaKeywords.en) || '',
    description: (metaDescriptions[locale] || metaDescriptions.en) || '',
  };
  store.dispatch(setMetaData(metaData));

  // JUST data for this page, not shared
  return {
    pathname,
    metaData,
    locale,
    wssUri: wssUri(req),
    hostName: getHostName(req),
    isMobile: checkMobile(isServer, req),
  };
};
